<template>
    <div class="notify" :class="`notify-${type}`">
        <icon name="close" class="notify-closer" v-if="closable" @click="$emit('close')"/>
        <div class="notify-title" v-if="title !== null || icon !== null">
            <icon :name="icon" v-if="icon !== null" class="notify-icon"/>
            <template v-if="title !== null">{{ title }}</template>
        </div>
        <div class="notify-body" v-if="body !== null" v-html="body"/>
        <div class="notify-footer" v-if="actions.length > 0">
            <panel xs="wrap" space="1">
                <btn v-for="(action, index) in actions"
                     :key="index"
                     v-bind="mergeActionDefaults(action)"
                />
            </panel>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {type: String, default: null},
            body: {type: String, default: null},
            type: {type: String, default: 'default'},
            icon: {type: String, default: null},
            closable: {type: Boolean, default: true},
            timeout: {type: Number, default: null},
            actions: {type: Array, default: () => []},
        },

        data() {
            return {
                runningTimeout: null,
            };
        },

        methods: {
            mergeActionDefaults(action) {
                return {size: 'sm', theme: 'secondary', ...action};
            },
        },

        mounted() {
            if (this.timeout !== null) {
                this.runningTimeout = setTimeout(() => {
                    this.$emit('close');
                }, this.timeout * 1000);
            }
        },

        destroyed() {
            clearTimeout(this.runningTimeout);
        },
    };
</script>